import { InAppMessageUi } from "../../InAppMessageUi"
import { InAppMessageView } from "../InAppMessageView"
import { ScriptInAppMessageView } from "../script/ScriptInAppMessageView"
import { InAppMessageRenderScriptLoader } from "../../script/InAppMessageRenderScriptLoader"
import InAppMessageRenderTypeResolver from "../../internal/InAppMessageRenderTypeResolver"
import { InAppMessageViewStatus } from "../InAppMessageViewStatus"
import { HackleInAppMessageLifecycleRegistry } from "../script/InAppMessageLifecycleRegistry"
import { InAppMessagePresentationContext } from "../../../present/presentation/InAppMessagePresentationContext"
import { InAppMessageViewFactory } from "./InAppMessageViewFactory"

export class ScriptInAppMessageViewFactory implements InAppMessageViewFactory {
  private readonly supportedDisplayTypes = ["MODAL", "BANNER", "BOTTOM_SHEET", "NONE"] as const
  constructor(private readonly scriptLoader: InAppMessageRenderScriptLoader) {}

  static create(scriptLoader: InAppMessageRenderScriptLoader): ScriptInAppMessageViewFactory {
    return new ScriptInAppMessageViewFactory(scriptLoader)
  }

  create(context: InAppMessagePresentationContext, ui: InAppMessageUi): InAppMessageView | null {
    const renderTypeResolver = new InAppMessageRenderTypeResolver()
    const viewStatus = new InAppMessageViewStatus()
    const lifecycleRegistry = new HackleInAppMessageLifecycleRegistry()

    switch (context.message.layout.displayType) {
      case "HTML":
        throw new Error(
          `Invalid displayType[HTML] found. Can't create InAppMessageView. (key=${context.inAppMessage.key})`
        )

      case "MODAL":
      case "BANNER":
      case "BOTTOM_SHEET":
        return new ScriptInAppMessageView(
          this.scriptLoader,
          context,
          ui,
          renderTypeResolver,
          viewStatus,
          lifecycleRegistry
        )
      case "NONE":
        return null
    }
  }

  supports(context: InAppMessagePresentationContext): boolean {
    return this.supportedDisplayTypes.some((it) => it === context.message.layout.displayType)
  }
}
